export default __webpack_public_path__ + "static/N0212-73a98c424e3cfa90f830afa86b6b62ad.png";